import { render, staticRenderFns } from "./savingIndicator.template?vue&type=template&id=cd086dc2&lang=pug&"
import script from "./savingIndicator.client?vue&type=script&lang=ts&"
export * from "./savingIndicator.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd086dc2')) {
      api.createRecord('cd086dc2', component.options)
    } else {
      api.reload('cd086dc2', component.options)
    }
    module.hot.accept("./savingIndicator.template?vue&type=template&id=cd086dc2&lang=pug&", function () {
      api.rerender('cd086dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/savingIndicator/savingIndicator.component.vue"
export default component.exports